import { render } from "./ContactFaq.vue?vue&type=template&id=c5b74212&scoped=true"
import script from "./ContactFaq.vue?vue&type=script&lang=js"
export * from "./ContactFaq.vue?vue&type=script&lang=js"

import "./ContactFaq.vue?vue&type=style&index=0&id=c5b74212&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5b74212"]])

export default __exports__